import React from "react";
import PropTypes from "prop-types";
import "./index.css";

const generalInfoColumnUnitPropTypes = {
  key: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
};

export const GeneralInfoPropTypes = {
  leftSideRenderElements: PropTypes.arrayOf(
    PropTypes.exact({
      ...generalInfoColumnUnitPropTypes,
    }),
  ).isRequired,
  rightSideRenderElements: PropTypes.arrayOf(
    PropTypes.exact({
      ...generalInfoColumnUnitPropTypes,
    }),
  ).isRequired,
};

function GeneralInfo({ leftSideRenderElements, rightSideRenderElements }) {
  function GeneralInfoColumnUnit(renderElement) {
    return (
      <div
        key={renderElement.key}
        className="general-info-item"
      >
        <span className="general-info-title">{renderElement.label}: </span>
        {renderElement.value}
      </div>
    );
  }

  return (
    <div className="general-info">
      <div className="general-info-left-column">
        {leftSideRenderElements.map((leftSideRenderElement) =>
          GeneralInfoColumnUnit(leftSideRenderElement),
        )}
      </div>
      <div className="general-info-right-column">
        {rightSideRenderElements.map((rightSideRenderElement) =>
          GeneralInfoColumnUnit(rightSideRenderElement),
        )}
      </div>
    </div>
  );
}

export default GeneralInfo;

GeneralInfo.propTypes = {
  ...GeneralInfoPropTypes,
};
